// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-box {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  /* .posnavbar-bottom-bar is fixed at 1200 — stay above it, below drawers (1300+) */
  z-index: 1250;
  background-color: rgba(15, 23, 42, 0.4);
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.dark .main-box {
  background-color: rgba(0, 0, 0, 0.6);
}

.container-box {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 80vw;
  padding: 3rem 2.5rem;
  background: radial-gradient(circle at top, rgba(16, 185, 129, 0.08), transparent 35%), white;
  box-shadow: -10px 0 50px rgba(15, 23, 42, 0.15);
  border-left: 1px solid #f1f5f9;
  border-radius: 0;
  box-sizing: border-box;
  animation: slideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  overflow-y: auto;
}

.dark .container-box {
  background: radial-gradient(circle at top, rgba(16, 185, 129, 0.12), transparent 35%), #1e293b;
  border-left-color: #334155;
  box-shadow: -10px 0 50px rgba(0, 0, 0, 0.4);
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}

.success-icon-wrapper {
  width: 7rem;
  height: 7rem;
  background-color: #ecfdf5;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
  position: relative;
}

.dark .success-icon-wrapper {
  background-color: rgba(16, 185, 129, 0.1);
}

.success-icon-svg {
  width: 4rem;
  height: 4rem;
  color: #10b981;
}

.order-success-title {
  font-size: 1.875rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 0.5rem 0;
}

.dark .order-success-title {
  color: #f1f5f9;
}

.order-id-text {
  font-size: 1.125rem;
  color: #64748b;
  margin: 0 0 0.5rem 0;
  font-weight: 500;
}

.dark .order-id-text {
  color: #94a3b8;
}

.payment-details-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.timer-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1rem;
}

.timer-instruction-text {
  font-size: 0.875rem;
  font-weight: 600;
  color: #64748b;
  text-align: center;
  margin: 0.5rem 0 0 0;
}

.dark .timer-instruction-text {
  color: #94a3b8;
}

.change-refund-text {
  font-size: 2.25rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0.5rem 0;
}

.dark .change-refund-text {
  color: #f1f5f9;
}

.payment-method-text {
  font-size: 0.875rem;
  font-weight: 500;
  color: #047857;
  margin: 0 0 2rem 0;
}

.dark .payment-method-text {
  color: #34d399;
}

.action-buttons-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;
  width: 100%;
  max-width: 28rem;
  margin-bottom: 2rem;
}

.action-button-item {
  white-space: nowrap;
  font-size: 0.875rem;
  font-weight: 600;
  padding: 0.5rem 1rem;
  height: 6rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  border-radius: 1rem;
  border: 2px solid #e2e8f0;
  background-color: transparent;
  color: #64748b;
  transition: all 0.2s ease;
  cursor: pointer;
}

.action-button-item:not(:disabled):hover {
  border-color: #94a3b8;
  background-color: #f8fafc;
  color: #0f172a;
}

.action-button-item:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.dark .action-button-item {
  border-color: #334155;
  color: #94a3b8;
}

.action-button-icon {
  width: 2rem;
  height: 2rem;
  opacity: 0.8;
}

.order-complete-button-container {
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 1rem;
}

.continue-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  white-space: nowrap;
  font-size: 0.875rem;
  font-weight: 600;
  min-height: 2.5rem;
  height: 3.5rem;
  padding: 0 3rem;
  border-radius: 1rem;
  background-color: #0f172a;
  color: #ffffff;
  border: 1px solid #1e293b;
  cursor: pointer;
  box-shadow:
    0 10px 15px -3px rgba(0, 0, 0, 0.1),
    0 4px 6px -2px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease;
}

.continue-button:hover {
  background-color: #1e293b;
  transform: translateY(-2px);
  box-shadow:
    0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.continue-button:active {
  transform: translateY(0);
}

.continue-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.dark .continue-button {
  background-color: #f8fafc;
  color: #0f172a;
  border-color: #e2e8f0;
}

.dark .continue-button:hover {
  background-color: #f1f5f9;
}

.continue-button-icon {
  width: 1.25rem;
  height: 1.25rem;
  margin-left: 0.5rem;
}

.order-placed-gif {
  height: 18rem;
  margin-top: -1rem;
  object-fit: contain;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.5rem;
}

.loading-text {
  font-size: 0.875rem;
  font-weight: 700;
  color: #64748b;
  text-align: center;
  margin: 0;
}

.dark .loading-text {
  color: #94a3b8;
}

@media (max-width: 600px) {
  .container-box {
    width: 100vw;
    border-radius: 0;
    padding: 2rem 1.5rem;
  }
}

.timer-text-white {
  color: inherit;
  margin-left: 0.25rem;
}

.timer-text-red {
  color: #ef4444 !important;
  margin-left: 0.25rem;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/CompleteOrder.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,kFAAkF;EAClF,aAAa;EACb,uCAAuC;EACvC,aAAa;EACb,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,4FAA4F;EAC5F,+CAA+C;EAC/C,8BAA8B;EAC9B,gBAAgB;EAChB,sBAAsB;EACtB,qDAAqD;EACrD,gBAAgB;AAClB;;AAEA;EACE,8FAA8F;EAC9F,0BAA0B;EAC1B,2CAA2C;AAC7C;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf;;sCAEoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B;;wCAEsC;AACxC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;EACtB;AACF;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;AACtB","sourcesContent":[".main-box {\n  width: 100vw;\n  height: 100vh;\n  position: fixed;\n  top: 0;\n  left: 0;\n  /* .posnavbar-bottom-bar is fixed at 1200 — stay above it, below drawers (1300+) */\n  z-index: 1250;\n  background-color: rgba(15, 23, 42, 0.4);\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n\n.dark .main-box {\n  background-color: rgba(0, 0, 0, 0.6);\n}\n\n.container-box {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  width: 80vw;\n  padding: 3rem 2.5rem;\n  background: radial-gradient(circle at top, rgba(16, 185, 129, 0.08), transparent 35%), white;\n  box-shadow: -10px 0 50px rgba(15, 23, 42, 0.15);\n  border-left: 1px solid #f1f5f9;\n  border-radius: 0;\n  box-sizing: border-box;\n  animation: slideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1);\n  overflow-y: auto;\n}\n\n.dark .container-box {\n  background: radial-gradient(circle at top, rgba(16, 185, 129, 0.12), transparent 35%), #1e293b;\n  border-left-color: #334155;\n  box-shadow: -10px 0 50px rgba(0, 0, 0, 0.4);\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateX(100%);\n  }\n  to {\n    transform: translateX(0);\n  }\n}\n\n.success-icon-wrapper {\n  width: 7rem;\n  height: 7rem;\n  background-color: #ecfdf5;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 2rem;\n  position: relative;\n}\n\n.dark .success-icon-wrapper {\n  background-color: rgba(16, 185, 129, 0.1);\n}\n\n.success-icon-svg {\n  width: 4rem;\n  height: 4rem;\n  color: #10b981;\n}\n\n.order-success-title {\n  font-size: 1.875rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0 0 0.5rem 0;\n}\n\n.dark .order-success-title {\n  color: #f1f5f9;\n}\n\n.order-id-text {\n  font-size: 1.125rem;\n  color: #64748b;\n  margin: 0 0 0.5rem 0;\n  font-weight: 500;\n}\n\n.dark .order-id-text {\n  color: #94a3b8;\n}\n\n.payment-details-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 100%;\n}\n\n.timer-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.timer-instruction-text {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: #64748b;\n  text-align: center;\n  margin: 0.5rem 0 0 0;\n}\n\n.dark .timer-instruction-text {\n  color: #94a3b8;\n}\n\n.change-refund-text {\n  font-size: 2.25rem;\n  font-weight: 700;\n  color: #0f172a;\n  margin: 0.5rem 0;\n}\n\n.dark .change-refund-text {\n  color: #f1f5f9;\n}\n\n.payment-method-text {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #047857;\n  margin: 0 0 2rem 0;\n}\n\n.dark .payment-method-text {\n  color: #34d399;\n}\n\n.action-buttons-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 1rem;\n  width: 100%;\n  max-width: 28rem;\n  margin-bottom: 2rem;\n}\n\n.action-button-item {\n  white-space: nowrap;\n  font-size: 0.875rem;\n  font-weight: 600;\n  padding: 0.5rem 1rem;\n  height: 6rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  border-radius: 1rem;\n  border: 2px solid #e2e8f0;\n  background-color: transparent;\n  color: #64748b;\n  transition: all 0.2s ease;\n  cursor: pointer;\n}\n\n.action-button-item:not(:disabled):hover {\n  border-color: #94a3b8;\n  background-color: #f8fafc;\n  color: #0f172a;\n}\n\n.action-button-item:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.dark .action-button-item {\n  border-color: #334155;\n  color: #94a3b8;\n}\n\n.action-button-icon {\n  width: 2rem;\n  height: 2rem;\n  opacity: 0.8;\n}\n\n.order-complete-button-container {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  margin-top: 1rem;\n}\n\n.continue-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  white-space: nowrap;\n  font-size: 0.875rem;\n  font-weight: 600;\n  min-height: 2.5rem;\n  height: 3.5rem;\n  padding: 0 3rem;\n  border-radius: 1rem;\n  background-color: #0f172a;\n  color: #ffffff;\n  border: 1px solid #1e293b;\n  cursor: pointer;\n  box-shadow:\n    0 10px 15px -3px rgba(0, 0, 0, 0.1),\n    0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  transition: all 0.2s ease;\n}\n\n.continue-button:hover {\n  background-color: #1e293b;\n  transform: translateY(-2px);\n  box-shadow:\n    0 20px 25px -5px rgba(0, 0, 0, 0.1),\n    0 10px 10px -5px rgba(0, 0, 0, 0.04);\n}\n\n.continue-button:active {\n  transform: translateY(0);\n}\n\n.continue-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n  box-shadow: none;\n}\n\n.dark .continue-button {\n  background-color: #f8fafc;\n  color: #0f172a;\n  border-color: #e2e8f0;\n}\n\n.dark .continue-button:hover {\n  background-color: #f1f5f9;\n}\n\n.continue-button-icon {\n  width: 1.25rem;\n  height: 1.25rem;\n  margin-left: 0.5rem;\n}\n\n.order-placed-gif {\n  height: 18rem;\n  margin-top: -1rem;\n  object-fit: contain;\n}\n\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1.5rem;\n}\n\n.loading-text {\n  font-size: 0.875rem;\n  font-weight: 700;\n  color: #64748b;\n  text-align: center;\n  margin: 0;\n}\n\n.dark .loading-text {\n  color: #94a3b8;\n}\n\n@media (max-width: 600px) {\n  .container-box {\n    width: 100vw;\n    border-radius: 0;\n    padding: 2rem 1.5rem;\n  }\n}\n\n.timer-text-white {\n  color: inherit;\n  margin-left: 0.25rem;\n}\n\n.timer-text-red {\n  color: #ef4444 !important;\n  margin-left: 0.25rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
